import { Fragment, useEffect, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { OwlCarousel as ReactOwlCarousel } from "../../Layout/Common/owlCarousel";
import { fetchBoughtTogetherProducts } from "../../Layout/Common/algoliaInstantLib";
import { ProductCardAlgolia } from "../../Layout/Common/productCardAlgolia";

export const FrequentlyBoughtTogether = ({ params }) => {
  const [productItems, setProductItems] = useState(null);
  const [pageData, setPageData] = useState(null);
  useEffect(() => {
    setProductItems(null);
    if (params) setPageData(params);
    if (params.isFamily == false && params.productId) {
      loadItems(params.productId);
    }
  }, [params]);

  const loadItems = async (productId) => {
    let items = await fetchBoughtTogetherProducts(productId);
    if (isValidArray(items)) {
      setProductItems(items);
    }
  };

  return (
    <Fragment>
      {pageData && pageData.isFamily == false && pageData.productId && isValidArray(productItems) && (
        <section className="proSection relatedProduct-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                <div className="subcategory-title">
                  <h4>Frequently Bought Together</h4>
                </div>
              </div>
            </div>
            <div className="row row-spacing">
              <div className="col-lg-12">
                <ReactOwlCarousel
                  className="relatedProduct-list"
                  loop={false}
                  items={5}
                  dots={true}
                  autoplay={false}
                  responsive={{
                    0: { items: 1 },
                    430: { items: 2 },
                    540: { items: 3 },
                    991: { items: 5 },
                  }}
                >
                  {isValidArray(productItems) &&
                    productItems.map((row, index) => (
                      <div className="item mt-3" key={index}>
                        <ProductCardAlgolia data={row} />
                      </div>
                    ))}
                </ReactOwlCarousel>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
